/***** Begin AgentFlyout Scripts *****/

var AgentFlyoutJS = {

  defaultUserLocation: "",
  SCPageName: "",
  emailAgentIconText: "",
  visitAgentIconText: "",
  getDirectionsLinkText: "",
  callAgentLinkText: "",
  afoNumberAgents: "",
  agentsToDisplay: "",
  isCustomer: "",
  reviewText: "",
  reviewEnding: "",
  isAgentFlyoutCall: false,
  isAgentLoaded: true,

  initializeTabEvent: function ()
  {
      // agent open
      $(".AgentFlyout .agent-tab").on("click", "a", function (e) {
          e.preventDefault();
          var agentTabWidth = $(".agent-tab").outerWidth();
          $(".agent-flyout-inner").show(function () { $(".agent-flyout-inner").animate({ "right": "0px" }), 500 });
          $(".agent-tab").animate({ "right": "-" + agentTabWidth + "px" }, 500, function () { $(".agent-tab").hide() });
      });

      // agent close
      $(".AgentFlyout .agent-flyout-inner").on("click", ".agent-close", function (e) {
          e.preventDefault();
          var agentFlyoutWidth = $(".agent-flyout-inner").outerWidth() + $(".agent-close").outerWidth();
          $(".agent-flyout-inner").animate({ "right": "-" + agentFlyoutWidth + "px" }, 500, function () { $(".agent-flyout-inner").hide() });
          $(".agent-tab").show(function () { $(".agent-tab").animate({ "right": "0px" }, 500) });
      });
  },

  init: function (agentsToDisplay, isCustomer, reviewText, reviewEnding) {
      if (!isCustomer)
      {
          AgentFlyoutJS.agentsToDisplay = agentsToDisplay;
          AgentFlyoutJS.isCustomer = isCustomer;
          AgentFlyoutJS.reviewText = reviewText;
          AgentFlyoutJS.reviewEnding = reviewEnding;
          AgentFlyoutJS.isAgentFlyoutCall = true;
          AgentFlyoutJS.isAgentLoaded = false;
          bsCommon.retrieveAgents();
      }
      else {
          AgentFlyoutJS.setUpPagination(isCustomer);
          setTimeout(function () { AgentFlyoutJS.checkAgentImages() }, 1000);
      }
  },
  agentCallBack: function (result)
  {
      if (AgentFlyoutJS.isAgentLoaded === false) {
          AgentFlyoutJS.parseAgentList(result, AgentFlyoutJS.agentsToDisplay, AgentFlyoutJS.isCustomer, AgentFlyoutJS.reviewText, AgentFlyoutJS.reviewEnding);
          AgentFlyoutJS.isAgentLoaded = true;
      }
  },
  subscribeToEvents: function (agentsToDisplay, isCustomer, reviewText, reviewEnding)
  {
    //globalEvents.Event('agentListUpdated').subscribe(function (result) { AgentFlyoutJS.parseAgentList(result, agentsToDisplay, isCustomer, reviewText, reviewEnding); });
    globalEvents.Event('agentListCleared').subscribe(function () { AgentFlyoutJS.clearAgentList(); });
  },

  setUserLocation: function()
  {
    if (AgentFlyoutJS.defaultUserLocation === "")
    {
      AgentFlyoutJS.defaultUserLocation = $(".AgentFlyout .agent-info .userLocation").html();
    }

    if ((bsCommon.userLocationJson() != null) && (bsCommon.userLocationJson() != "") && (bsCommon.userLocationJson().PostalCode != ""))
    {
      $(".AgentFlyout .agent-info .userLocation").html(AgentFlyoutJS.defaultUserLocation + bsCommon.userLocationJson().PostalCode);

      $(".AgentFlyout .quote-info .quote-location span:first").html(bsCommon.userLocationJson().PostalCode);
    }
  },

  clearAgentList: function()
  {    
      $('.AgentFlyout .afoAgentListing').find('li:first').remove();

      if ($(".AgentFlyout .afoAgentListing").children().length == 0) {
          var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
          $('.AgentFlyout .afoAgentListing').append(myHTML);
      }
  },

  parseAgentList: function (agentList, agentsToDisplay, isCustomer, reviewText, reviewEnding)
  {
      if (AgentFlyoutJS.isAgentLoaded === false)
      {
          if (agentList !== null)
          {
              try
              {
                  var myAgents = JSON.parse(agentList);
                  if ((myAgents.Agents !== null) && (myAgents.Agents !== "null") && (myAgents.Agents.length > 0))
                  {
                      if (myAgents.Agents.length < agentsToDisplay)
                      {
                          agentsToDisplay = myAgents.Agents.length;
                      }

                      $('.AgentFlyout .carousel-inner').html("");

                      if (agentsToDisplay === 1)
                      {
                          $('.slides_prev-agentsnearyou .slides_next-agentsnearyou').hide();
                      }

                      for (var i = 0; i < agentsToDisplay; i++) 
                      {
                          var myHTML = "";
                          var myAgencyName = myAgents.Agents[i].FullName;

                          if ((typeof myAgencyName === 'undefined') || (myAgencyName === '') || (myAgencyName === ' '))
                          {
                              myAgencyName = myAgents.Agents[i].CFAgencyName;
                          }
                          if (typeof myAgencyName === 'undefined')
                          {
                              myAgencyName = "Not Available";
                          }

                          myHTML += "<li class='slides-inner-agentflyout'>";
                          myHTML += "<div class='agentCard'>";
                          myHTML += "<div class='agentContactIcons'>";
                          myHTML += "<ul>";
                          myHTML += "<li class='agentContactEmail'><a href='mailto:" + myAgents.Agents[i].CFEmailAddress + "' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Email&#39;, &#39;AgentFlyout&#39;]);'><i class='fa fa-envelope' aria-hidden='true' title='" + AgentFlyoutJS.emailAgentIconText + "'></i></a></li>";
                          myHTML += "<li class='agentContactWebsite'><a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|website' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentFlyout&#39;]);'><i class='fa fa-desktop' aria-hidden='true' title='" + AgentFlyoutJS.visitAgentIconText + "'></i></a></li>";
                          if (myAgents.Agents[i].AgentFacebookURL) {
                              myHTML += "<li class='agentContactFacebook'><a href='" + myAgents.Agents[i].AgentFacebookURL + "' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Facebook&#39;]);'><i class='fa fa-facebook' aria-hidden='true' title='" + AgentFlyoutJS.AgentFaceBookURLText + "'></i></a></li>";
                          }
                          if (myAgents.Agents[i].AgentTwitterURL) {
                              myHTML += "<li class='agentContactTwitter'><a href='" + myAgents.Agents[i].AgentTwitterURL + "' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;SocialIcons&#39;, [&#39;Twitter&#39;]);'><i class='fa fa-twitter' aria-hidden='true' title='" + AgentFlyoutJS.AgentTwitterURLText + "'></i></a></li>";
                          }
                          myHTML += "</ul>";
                          myHTML += "</div>";
                          myHTML += "<div class='agentPhoto'>";
                          myHTML += "<a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|website' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentFlyout&#39;]);' title='" + AgentFlyoutJS.visitAgentIconText + "' class='agentWeb' name='&lpos=AgentsNearYou'><img class='agentPhotoImg' src='" + myAgents.Agents[i].AgentPhotoURL + "' alt='" + myAgencyName + "' /></a>";
                          myHTML += "</div>";
                          myHTML += "<div class='agentInfo'>";
                          myHTML += "<div class='agentNamePhone'>";
                          myHTML += "<div class='agentName'><a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|website' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentFlyout&#39;]);' title='" + AgentFlyoutJS.visitAgentIconText + "' class='agentWeb' name='&lpos=AgentsNearYou'>" + myAgencyName + "</a></div>";
                          myHTML += "<a href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|5starRatings' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentFlyout&#39;]);' class='afoAgentStars-" + myAgents.Agents[i].ProducerNumber + "'/></a>";
                          myHTML += "<div class='agentPhone'>";
                          myHTML += "<i class='fa fa-phone' aria-hidden='true'></i>";
                          myHTML += "<a href='tel:" + myAgents.Agents[i].Telephone + "' name='&lpos=AgentFlyout' title='" + AgentFlyoutJS.callAgentLinkText + "' class='agentPhone' name='&lpos=AgentsNearYou'>" + myAgents.Agents[i].Telephone + "</a>";
                          myHTML += "</div>";
                          myHTML += "</div>";
                          myHTML += "</div>";

                          var j = 0;
                          var agentLanguages = "";
                          for (; j < myAgents.Agents[i].Languages.length; j++) {
                              if ((myAgents.Agents[i].Languages[j].toUpperCase() != "ENGLISH")) {
                                  if (agentLanguages != "") {
                                      agentLanguages = agentLanguages + ", " + myAgents.Agents[i].Languages[j];
                                  }
                                  else {
                                      agentLanguages = myAgents.Agents[i].Languages[j];
                                  }
                              }
                          }
                          agentLanguages = agentLanguages.substring(0, 34);

                          if (agentLanguages != "") {
                              myHTML += "<div class='agentLanguagesDiv'>";
                              myHTML += "<i class='glyphicon glyphicon-comment'> </i>";
                              myHTML += "<div class='agentLanguagesLink'>";
                              myHTML += "<span>" + agentLanguages + "</span>";

                              if (j >= 4){
                                  myHTML += " <a name='&lpos=agentFlyout' class='agentPhone' href='" + myAgents.Agents[i].AgentWebsiteURL + "?intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|website' name='&lpos=AgentFlyout' onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Website&#39;, &#39;AgentFlyout&#39;]);' title='" + AgentFlyoutJS.visitAgentIconText + "' class='agentWeb' name='&lpos=AgentsNearYou'>" + "(+)" + "</a>";
                              }
                              myHTML += "</div></div>";
                          }

                          myHTML += "<div class='agentAddressDiv'>";
                          myHTML += "<div class='agentAddressIcon'><i class='fa fa-map-marker' aria-hidden='true'></i></div>";
                          myHTML += "<div class='agentAddressLink'>";
                          myHTML += "<a class='agentAddress' title='" + AgentFlyoutJS.getDirectionsLinkText + "' target='_blank'  onclick='ProcessMetrics(&#39;agentBusinessCard&#39;, [&#39;Agent Directions&#39;, &#39;AgentFlyout&#39;]);' href='https://www.bing.com/mapspreview?rtp=~adr.address." + myAgents.Agents[i].Address.Line1.replace(" ", "%20") + "," + myAgents.Agents[i].Address.City.replace(" ", "%20") + "," + myAgents.Agents[i].Address.AddressState + "," + myAgents.Agents[i].Address.ZipCode + "&intcid=" + AgentFlyoutJS.SCPageName + "|AgentFlyout|AgentFlyout' name='&lpos=AgentFlyout'>";
                          myHTML += "<p>" + myAgents.Agents[i].Address.Line1 + "</p>";
                          myHTML += "<p>" + myAgents.Agents[i].Address.City + ", " + myAgents.Agents[i].Address.AddressState + " " + myAgents.Agents[i].Address.ZipCode + "</p>";
                          myHTML += "</a>";
                          myHTML += "</div>";
                          myHTML += "</div>";
                          myHTML += "</div>";
                          myHTML += "</li>";

                          $('.AgentFlyout .afoAgentListing').append(myHTML);

                          if ($('.reviews-' + myAgents.Agents[i].ProducerNumber).length === 0)
                          {
                              globalEvents.Event('agentReviewRetrieved').subscribe(function (agentNumber) { AgentFlyoutJS.getReviewDiv(agentNumber, reviewText, reviewEnding); });
                              bsCommon.retrieveAgentReview(myAgents.Agents[i].ProducerNumber);
                          }
                          else
                          {
                              AgentFlyoutJS.getReviewDiv(myAgents.Agents[i].ProducerNumber, reviewText, reviewEnding);
                          }
                      }

                      $('.AgentFlyout .afoAgentListing').find('li:first').remove();

                      if ($(".AgentFlyout .afoAgentListing").children().length == 0) {
                          var myHTML = "<li><div class='agentsFindMessage'>No Agents Found.</div></li>";
                          $('.AgentFlyout .afoAgentListing').append(myHTML);
                      }

                      AgentFlyoutJS.setUpPagination(isCustomer);
                      AgentFlyoutJS.setNavigationText();
                      setTimeout(function () { AgentFlyoutJS.checkAgentImages() }, 1000);
                      AgentFlyoutJS.HasAgentsLoaded = true;
                  }
                  else
                  {
                      AgentFlyoutJS.clearAgentList();
                  }
              }
              catch (e)
              {
                  AgentFlyoutJS.clearAgentList();
                  AgentFlyoutJS.isAgentLoaded = false;
              }
          }
          else
          {
              AgentFlyoutJS.clearAgentList();
          }
      }
  },

  checkAgentImages: function ()
  {
    try
    {
        for (var i = 0; i < $('.AgentFlyout').find('img.agentPhotoImg').length; i++)
      {
        if (!bsCommon.isImageOk($('.AgentFlyout').find('img.agentPhotoImg')[i]))
        {
            $($('.AgentFlyout').find('img.agentPhotoImg')[i]).attr('src', '/resources/images/agent-mia.jpg');
        }
      }
    }
    catch (err)
    {
    }
  },

  setUpPagination: function (isCustomer)
  {
    if (isCustomer === "False" || !isCustomer)
    {
        $('#AgentFlyoutContainer .afoAgentListing').easyPaginate({
            step: 2,
            container: 'afo-agent-nav',
            controls: 'pagination-nav'
        });
    }
    else
    {
        $('#AgentFlyoutContainer .afoAgentListing').easyPaginate({
            step: 1,
            container: 'afo-agent-nav',
            controls: 'pagination-nav'
        });
    }
  },

  setNavigationText: function ()
  {
      if (typeof myAFOAgentPrevious != 'undefined')
      {
          $('.AgentFlyout .pagination-nav .pgPrev').children('a').html(myAFOAgentPrevious);
      }
      if (typeof myAFOAgentNext != "undefined")
      {
          $('.AgentFlyout .pagination-nav .pgNext').children('a').html(myAFOAgentNext);
      }
  },

  getReviewDiv: function (agentNumber, reviewText, reviewEnding)
  {
    if ($('.reviews-' + agentNumber).length !== 0)
    {
        $('.afoAgentStars-' + agentNumber).empty();
        $('.afoAgentStars-' + agentNumber).append($('.reviews-' + agentNumber).clone().wrap('<div>').parent().html());

        if ($('.afoAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .count')[0].innerHTML !== "1")
      {
        reviewText += reviewEnding;
      }

        $('.afoAgentStars-' + agentNumber + ' .reviews-' + agentNumber + ' .reviewText').html(reviewText);
    }
  }

};

/***** End AgentFlyout Scripts *****/